import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';
import { initialState } from './slice';

const selectDomain = (state: RootState) => state.customerEditor || initialState;

export const selectCustomerEditor = createSelector(
  [selectDomain],
  customerEditorState => customerEditorState,
);

export const selectCountries = createSelector(
  [selectDomain],
  ({ countries, countriesLoading }) => ({
    countries: countries || [],
    isLoadingCountries: countriesLoading,
  }),
);
